import { BaseService } from '../common/service/base.service';

export class BaseTranslateService extends BaseService {
  constructor(apiVersion: string = 'v1') {
    super(process.env.REACT_APP_TRANSLATE_API_URL || '', apiVersion);
  }
}
